<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab">{{ $t("statisticsPage.tabAutomaticReport") }}</v-tab>
      <v-tab-item>
        <div>
          <v-form ref="form">
            <v-container>
              <v-layout wrap>
                <v-flex md2 sm12>
                  <v-select item-text="text" item-value="value" :items="typeOptions" v-model="selected_type"
                    @change="changeFilterMethod" :label="$t('statisticsPage.type')"></v-select>
                </v-flex>
                <v-flex md2 sm12>
                  <v-select item-text="text" item-value="value" :items="filterByOptions" v-model="selected_filter_by"
                    @change="changeFilterMethod" :label="$t('statisticsPage.filterBy')"></v-select>
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
                  <choose-date clearable :label="$t('statisticsPage.from')" v-model="from"></choose-date>
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
                  <choose-date clearable :label="$t('statisticsPage.to')" v-model="to"></choose-date>
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Month'">
                  <date-picker-multiple v-model="selected_month" />
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Year'">
                  <v-select :items="years" item-text="Year" v-model="selected_year" :label="$t('statisticsPage.selectYear')"
                    @change="changeFilterMethod"></v-select>
                </v-flex>
                <v-flex md2 sm12>
                  <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(true)" :loading="loading">{{
                    $t("statisticsPage.exportPdf") }}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </div>
        <div>
          <div class="options">
            <div v-for="(stat, index) in mainStats" :key="index" class="option">
              <div class="title">
                <span class="option-name">{{ statLabel(stat[0]) }}</span>
              </div>
              <div class="percentage">{{ $t("statisticsPage.percentage") }}: {{ parseFloat(stat[1] /
                (mainStats[0][1] + mainStats[1][1] + mainStats[2][1]) * 100).toFixed(2) }} <span class="symbol">%</span>
              </div>
              <div class="percentage">{{ $t("statisticsPage.count") }}: {{ stat[1] }}</div>
            </div>
          </div>
          <div class="options">
            <div v-for="(stat, index) in statistics" v-if="stat != null && index != 'static_constraints'" :key="index"
              class="option">
              <div class="title">
                <span class="option-name">{{ statLabel(index) }}</span>
              </div>
              <div class="percentage">{{ stat }}</div>
            </div>
          </div>
          <!-- <canvas style="height: 500px; width: 500px" ref="chart"></canvas> -->
        </div>
        <div>
          <!-- <canvas style="height: 500px; width: 500px" ref="pieChart"></canvas> -->
        </div>
      </v-tab-item>
      <v-tab :key="2" ripple active-class="tab"> {{ $t("statisticsPage.tabCustomReport") }} </v-tab>
      <v-tab-item>
        <div>
          <v-form ref="form">
            <v-container>
              <v-layout wrap>
                <v-flex md2 sm12>
                  <v-select item-text="text" item-value="value" :items="filterByOptions" v-model="selected_filter_by"
                    @change="changeFilterMethod" :label="$t('statisticsPage.filterBy')"></v-select>
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
                  <choose-date clearable :label="$t('statisticsPage.from')" v-model="customDateFrom"></choose-date>
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
                  <choose-date clearable :label="$t('statisticsPage.to')" v-model="customDateTo"></choose-date>
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Month'">
                  <date-picker-multiple v-model="custom_month" />
                </v-flex>
                <v-flex md2 sm12 v-if="selected_filter_by == 'Year'">
                  <v-select :items="years" item-text="Year" v-model="custom_year" :label="$t('statisticsPage.selectYear')"
                    @change="changeFilterMethod"></v-select>
                </v-flex>
                <v-flex md2 sm12>
                  <v-select item-text="text" item-value="value" :items="driverTypeOptions"
                    v-model="customFilter.driver_type" :label="$t('statisticsPage.driverType')"></v-select>
                </v-flex>
                <v-flex md2 sm12 v-if="customFilter.driver_type == 'Specific'">
                  <v-autocomplete v-model="customFilter.selectedCaptain" clearable dense :items="captains"
                    :loading="loading" :search-input.sync="searchCaptainParam" :label="$t('statisticsPage.captain')" item-text="text"
                    item-value="id" :placeholder="$t('statisticsPage.searchForCaptain')" no-filter :debounce-search="250"><template
                      slot="item" slot-scope="captains">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="captains.item.first_name +
                          ' ' +
                          captains.item.last_name
                          "></v-list-tile-title>
                        <v-list-tile-sub-title v-html="captains.item.username"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md2 sm12>
                  <v-autocomplete v-model="customFilter.selectedUser" clearable dense :items="users" :loading="loading"
                    :search-input.sync="searchUserParam" :label="$t('statisticsPage.user')" item-text="text" item-value="id"
                    :placeholder="$t('statisticsPage.searchForUser')" no-filter :debounce-search="250"><template slot="item"
                      slot-scope="users">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="users.item.first_name + ' ' + users.item.last_name
                          "></v-list-tile-title>
                        <v-list-tile-sub-title v-html="users.item.username"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex md2 sm12>
                  <v-autocomplete v-model="customFilter.selectedPassenger" clearable dense :items="passengers"
                    :loading="loading" :search-input.sync="searchPassengerParam" :label="$t('statisticsPage.passenger')" item-text="text"
                    item-value="id" :placeholder="$t('statisticsPage.searchForPassenger')" no-filter :debounce-search="250"><template
                      slot="item" slot-scope="passengers">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="passengers.item.full_name"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="passengers.item.username"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container>
              <div class="options">
                <v-layout wrap>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionOrderType") }}</span>
                        <div>
                          <v-switch v-model="show.first" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.first">
                        <v-checkbox color="blue" :label="$t('statisticsPage.instant')" v-model="customFilter.instant" />
                      </div>
                      <div class="percentage" v-if="show.first">
                        <v-checkbox color="blue" :label="$t('statisticsPage.reservation')" v-model="customFilter.reservation" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionOrderStatus") }}</span>
                        <div>
                          <v-switch v-model="show.status" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.status">
                        <v-checkbox color="blue" :label="$t('statisticsPage.created')" v-model="customFilter.created" />
                      </div>
                      <div class="percentage" v-if="show.status">
                        <v-checkbox color="blue" :label="$t('statisticsPage.completed')" v-model="customFilter.completed" />
                      </div>
                      <div class="percentage" v-if="show.status">
                        <v-checkbox color="blue" :label="$t('statisticsPage.cancelled')" v-model="customFilter.cancelled" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionDestinationType") }}</span>
                        <div>
                          <v-switch v-model="show.second" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.second">
                        <v-checkbox color="blue" :label="$t('statisticsPage.destMc')" v-model="customFilter.mc" />
                      </div>
                      <div class="percentage" v-if="show.second">
                        <v-checkbox color="blue" :label="$t('statisticsPage.destPext')" v-model="customFilter.pext" />
                      </div>
                      <div class="percentage" v-if="show.second">
                        <v-checkbox color="blue" :label="$t('statisticsPage.destExt')" v-model="customFilter.ext" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionOrderOrigin") }}</span>
                        <v-switch v-model="show.third" color="blue"></v-switch>
                      </div>
                      <div class="percentage" v-if="show.third">
                        <v-checkbox color="blue" :label="$t('statisticsPage.originCc')" v-model="customFilter.cc" />
                      </div>
                      <div class="percentage" v-if="show.third">
                        <v-checkbox color="blue" :label="$t('statisticsPage.originApp')" v-model="customFilter.app" />
                      </div>
                      <div class="percentage" v-if="show.third">
                        <v-checkbox color="blue" :label="$t('statisticsPage.originHotel')" v-model="customFilter.hotel" />
                      </div>
                      <div class="percentage" v-if="show.third">
                        <v-checkbox color="blue" :label="$t('statisticsPage.originCompany')" v-model="customFilter.company" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionOrderCancellation") }}</span>
                        <v-switch v-model="show.forth" color="blue"></v-switch>
                      </div>

                      <div class="percentage" v-for="(item, i) in userCancellationReasons" :key="i" v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.ccCancelledWithReason', { reason: item.text })"
                          v-model="customFilter.userCancellationReasons[item.id]" />
                      </div>
                      <div class="percentage" v-for="(item, i) in captainCancellationReasons" :key="i"
                        v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.driverCancelledWithReason', { reason: item.text })"
                          v-model="customFilter.captainCancellationReasons[item.id]" />
                      </div>

                      <div class="percentage" v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.customerCancelled')" v-model="customFilter.customerCancelled" />
                      </div>
                      <div class="percentage" v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.hotelCancelled')" v-model="customFilter.hotelCancelled" />
                      </div>
                      <div class="percentage" v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.companyCancelled')" v-model="customFilter.companyCancelled" />
                      </div>
                      <div class="percentage" v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.companyCancelledAuto')"
                          v-model="customFilter.companyCancelledAuto" />
                      </div>
                      <div class="percentage" v-if="show.forth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.parentCancelledAuto')"
                          v-model="customFilter.parentCancelledAuto" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionReservationType") }}</span>
                        <div>
                          <v-switch v-model="show.fifth" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.fifth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.reservationNormal')" v-model="customFilter.normalReservation" />
                      </div>
                      <div class="percentage" v-if="show.fifth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.reservationTransformed')" v-model="customFilter.transformedReservation" />
                      </div>
                      <div class="percentage" v-if="show.fifth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.reservationShort')" v-model="customFilter.shortReservation" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionPaymentMethod") }}</span>
                        <div>
                          <v-switch v-model="show.sixth" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.sixth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.paymentInside')" v-model="customFilter.insidePayment" />
                      </div>
                      <div class="percentage" v-if="show.sixth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.paymentOutside')" v-model="customFilter.outsidePayment" />
                      </div>
                      <div class="percentage" v-if="show.sixth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.encompt')" v-model="customFilter.encomptPayment" />
                      </div>
                      <div class="percentage" v-if="show.sixth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.paymentFamily')" v-model="customFilter.familyPayment" />
                      </div>
                      <div class="percentage" v-if="show.sixth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.paymentCompany')" v-model="customFilter.companyPayment" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionVehicleType") }}</span>
                        <div>
                          <v-switch v-model="show.seventh" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-for="(item, i) in vehicle_types" :key="i" v-if="show.seventh">
                        <v-checkbox color="blue" :label="item.name" v-model="customFilter.vehicle_types[item.id]" />
                      </div>

                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionConstraints") }}</span>
                        <div>
                          <v-switch v-model="show.eighth" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-for="(item, i) in dynamic_constraints" :key="i" v-if="show.eighth">
                        <v-checkbox color="blue" :label="item.title" v-model="customFilter.constraints[item.value]" />
                      </div>
                      <div class="percentage" v-if="show.eighth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.priorityOrder')" v-model="customFilter.priority_order" />
                      </div>
                      <div class="percentage" v-if="show.eighth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.replacedWith2Cars')"
                          v-model="customFilter.replaced_with_cars" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionSpecialActions") }}</span>
                        <div>
                          <v-switch v-model="show.ninth" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.driverRedispatched')"
                          v-model="customFilter.driverRedispatched" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.editedBooking')" v-model="customFilter.edited" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.ccRedispatched')" v-model="customFilter.ccRedispatched" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.driverTransferred')" v-model="customFilter.driverTransferred" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.driverExchanged')" v-model="customFilter.driverExchanged" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.directDispatch')" v-model="customFilter.directDispatch" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.proposalRejected')" v-model="customFilter.RejectedProposal" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.noAnswerInStation')"
                          v-model="customFilter.noAnswerInStation" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.noAnswerFree')"
                          v-model="customFilter.noAnswerFree" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.gotPunished')" v-model="customFilter.gotPunished" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.clientChangedPaymentMethod')"
                          v-model="customFilter.paymentMethodChanging" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.extAffectedToSeasonal')"
                          v-model="customFilter.extAffectedToSeasonal" />
                      </div>
                      <div class="percentage" v-if="show.ninth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.dispatchedTwiceSameDriver')"
                          v-model="customFilter.dispatchTwice" />
                      </div>
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionComplaints") }}</span>
                        <div>
                          <v-switch v-model="show.tenth" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.tenth">
                        <v-checkbox color="blue" :label="$t('statisticsPage.hasComplaint')" v-model="customFilter.hasComplaints" />
                      </div>
                      <!-- <div class="percentage" v-if="show.tenth"> -->
                      <!-- <v-checkbox -->
                      <!-- color="blue" -->
                      <!-- label="On Booking" -->
                      <!-- v-model="customFilter.bookingComplaint" -->
                      <!-- /> -->
                      <!-- </div> -->
                      <!-- <div class="percentage" v-if="show.tenth"> -->
                      <!-- <v-checkbox -->
                      <!-- color="blue" -->
                      <!-- label="On Captain" -->
                      <!-- v-model="customFilter.captainComplaint" -->
                      <!-- /> -->
                      <!-- </div> -->
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma-2>
                    <div class="option">
                      <div class="title">
                        <span class="option-name">{{ $t("statisticsPage.sectionTips") }}</span>
                        <div>
                          <v-switch v-model="show.tips" color="blue"></v-switch>
                        </div>
                      </div>
                      <div class="percentage" v-if="show.tips">
                        <v-checkbox color="blue" :label="$t('statisticsPage.withTip')" v-model="customFilter.withTip" />
                      </div>
                      <div class="percentage" v-if="show.tips">
                        <v-checkbox color="blue" :label="$t('statisticsPage.withoutTip')" v-model="customFilter.withoutTip" />
                      </div>

                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma3 spacing-playground pa-6>
                    <div style="padding: 0 12px">
                      <vue-tags-input :allow-edit-tags="false" :avoid-adding-duplicates="true"
                        :placeholder="$t('statisticsPage.ordersDestinations')" v-model="tag" :tags="tags" :autocomplete-items="filteredItems"
                        @tags-changed="(newTags) => (tags = newTags)" :add-only-from-autocomplete="true" />
                    </div>
                  </v-flex>
                  <v-flex md2 sm12 ma3 spacing-playground pa-6>
                    <div style="padding: 0 12px">
                      <vue-tags-input :allow-edit-tags="false" :avoid-adding-duplicates="true"
                        :placeholder="$t('statisticsPage.ordersPickups')" v-model="tagPickup" :tags="tagsPickup"
                        :autocomplete-items="filteredPickups" @tags-changed="(newTags) => (tagsPickup = newTags)"
                        :add-only-from-autocomplete="true" />
                    </div>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout wrap>
                <v-flex md2 sm12 ma-2>
                  <v-btn v-if="customDateFrom && customDateTo" color="primary" dark class="mb-2 cbtn"
                    @click="getCustomReport(false, true)" :loading="loading">{{ $t("statisticsPage.getData") }}</v-btn>
                </v-flex>
                <v-flex md2 sm12 ma-2>
                  <v-btn color="primary" dark class="mb-2 cbtn" @click="clearFilter()" :loading="loading">{{
                    $t("statisticsPage.clearFilter") }}</v-btn>
                </v-flex>
                <v-flex md2 sm12 ma-2 v-if="message">
                  <v-btn color="primary" dark class="mb-2 cbtn" @click="getCustomReport(true, false)"
                    :loading="loading">{{
                    $t("statisticsPage.getPdf") }}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </div>
        <div>
          <v-container>
            <v-layout v-if="message">
              <v-flex justify-center mb-6 bg-surface-variant>
                <div class="option">
                  <div class="title">
                    <span class="option-name">{{ message }}</span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <div>
          <v-container v-if="bookings" infinite-scroll-disabled="!hasMoreData">
            <v-layout wrap>
              <v-flex xs4 v-for="order in bookings" :key="order.id">
                <div style="width: 100%; max-width: 300px; height: 100%">
                  <OrderCard style="width: 100%; max-width: 300px; height: 100%" :data="order"
                    @cancelled="removeOrder($event)" />
                </div>
              </v-flex>
            </v-layout>
            <v-pagination v-if="bookings.length != 0" v-model="currentPage" :length.sync="pagesCount"></v-pagination>
          </v-container>
        </div>
      </v-tab-item>



      <v-tab :key="3" ripple active-class="tab"> {{ $t("statisticsPage.tabOnlineCaptains") }} </v-tab>
      <v-tab-item>
        <ShiftLogsAvg />
      </v-tab-item>

      <v-tab v-if="hasPermission('COMPLAINTS_STATS')" :key="4" ripple active-class="tab"> {{ $t("statisticsPage.tabComplaintsStats") }} </v-tab>
      <v-tab-item v-if="hasPermission('COMPLAINTS_STATS')">
        <ComplaintsStats />
      </v-tab-item>

      <v-tab v-if="hasPermission('COMPLAINTS_STATS')" :key="5" ripple active-class="tab"> {{ $t("statisticsPage.tabCustomerAppStats") }} </v-tab>
      <v-tab-item v-if="hasPermission('COMPLAINTS_STATS')">
        <CustomerAppStats />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
// import Chart from "chart.js";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import DatePickerMultiple from "@/components/monaco/input/DatePickerMultiple";
import moment from "moment";
import { companyToday } from "@/util/companyTime";
import VueTagsInput from "@johmun/vue-tags-input";
import { array } from "yup/lib/locale";
import OrderCard from "@/components/dispatching/OrderCard";
import ComplaintsStats from "@/components/ComplaintsStats";
import CustomerAppStats from "@/components/CustomerAppStats";
import ShiftLogsAvg from "@/components/profile/captain/ShiftLogsAvg";

export default {
  name: "Statistics",
  title() {
    return this.$t("statisticsPage.pageTitle");
  },
  components: {
    DataTable,
    ChooseDate,
    DatePickerMultiple,
    VueTagsInput,
    OrderCard,
    ComplaintsStats,
    CustomerAppStats,
    ShiftLogsAvg
  },
  data() {
    return {
      statistics: [],
      mainStats: [],
      searchCaptainParam: "",
      searchUserParam: "",
      searchPassengerParam: "",
      captainCancellationReasons: [],
      userCancellationReasons: [],
      customDateFrom: null,
      customDateTo: null,
      message: null,
      show: {},
      captains: [],
      users: [],
      passengers: [],
      customFilter: {
        created: false,
        completed: false,
        cancelled: false,
        instant: false,
        reservation: false,
        shortReservation: false,
        vehicle_types: [],
        // constraints: false,
        mc: false,
        pext: false,
        ext: false,
        cc: false,
        app: false,
        hotel: false,
        company: false,
        //ccCancelled: false,
        // driverCancelledMissing: false,
        // driverCancelledDrunk: false,
        // driverCancelledSale: false,
        // driverCancelledErrorCreation: false,
        customerCancelled: false,
        hotelCancelled: false,
        companyCancelled: false,
        companyCancelledAuto: false,
        parentCancelledAuto: false,
        normalReservation: false,
        transformedReservation: false,
        insidePayment: false,
        outsidePayment: false,
        encomptPayment: false,
        familyPayment: false,
        companyPayment: false,
        priority_order: false,
        replaced_with_cars: false,
        driverRedispatched: false,
        ccRedispatched: false,
        driverTransferred: false,
        driverExchanged: false,
        directDispatch: false,
        RejectedProposal: false,
        noAnswerInStation: false,
        noAnswerFree: false,
        gotPunished: false,
        paymentMethodChanging: false,
        extAffectedToSeasonal: false,
        dispatchTwice: false,
        hasComplaints: false,
        bookingComplaint: false,
        captainComplaint: false,
        edited: false,
        constraints: [],
        captainCancellationReasons: [],
        userCancellationReasons: [],
        destinations: [],
        driver_type: "All",
        selectedCaptain: null,
        selectedUser: null,
        selectedPassenger: null,
        withTip: false,
        withoutTip: false
      },
      years: [],
      from: null,
      to: null,
      selectedYear: null,
      selected_filter_by: "Day",
      selected_day: null,
      selected_month: null,
      selected_year: null,
      custom_month: null,
      custom_year: null,
      selected_type: "All",
      reservation: true,
      instant: true,
      loading: false,
      // chart: null,
      dynamic_constraints: [],
      vehicle_types: [],
      autocompleteItems: [],
      autocompleteItemsPickup: [],
      tag: "",
      tags: [],
      tagPickup: "",
      tagsPickup: [],
      // filteredData: [
      //   instant =  false,
      // ],
      // chartData: {
      //   labels: [],
      //   datasets: [
      //     {
      //       label: "Data",
      //       backgroundColor: [
      //         "#FF6384",
      //         "#36A2EB",
      //         "#FFCE56",
      //         "#4BC0C0",
      //         "#9966FF",
      //         "#FFA07A",
      //       ],
      //       data: [],
      //     },
      //   ],
      // },
      // pieChartData: {
      //   labels: [],
      //   datasets: [
      //     {
      //       label: "Data",
      //       backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
      //       data: [],
      //     },
      //   ],
      // },
      // chart: null,
      // pieChart: null,
      bookings: [],
      currentPage: 0,
      pagesCount: 1,
      page: 1,
      pageSize: 8,
      hasMoreData: true,
      active: 0
    };
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i);
    this.selected_day = companyToday();
    this.from = this.selected_day;
    this.to = this.selected_day;
    this.customDateFrom = this.selected_day;
    this.customDateTo = this.selected_day;
    // this.renderChart();
    // this.renderPieChart();
    this.getData(false);
    this.getDynamicConstraints();
    this.getUserCancellationReasons();
    this.getCaptainCancellationReasons();
    this.searchClusters("");
    this.searchLocations();
    this.getVehicleTypes();
  },
  methods: {
    statLabel(key) {
      const i18nKey = `statisticsPage.statKeys.${key}`;
      if (this.$te(i18nKey)) {
        return this.$t(i18nKey);
      }
      return String(key).replace("___", "'").replaceAll("_", " ");
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (data && Array.isArray(data.data)) {
        return data.data;
      }
      return [];
    },
    getCaptains() {
      if (!this.searchCaptainParam) {
        return;
      }
      this.loading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchCaptainParam);
      this.axios
        .get(`captain/search`, { params })
        .then((res) => {
          this.captains = res.data.data.map((captain) => ({
            text:
              `${captain.full_name || ""}` + " " + `${captain.username || ""}`,
            ...captain,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUsers() {
      if (!this.searchUserParam) {
        return;
      }
      this.loading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchUserParam);
      params.append("allData", true);
      this.axios
        .get(`user`, { params })
        .then((res) => {
          this.users = this.normalizeCollection(res.data.data).map((user) => ({
            text: `${user.first_name || ""}`,
            ...user,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getUserCancellationReasons() {
      this.$store
        .dispatch("getUserCancellationReasons")
        .then((data) => {
          this.userCancellationReasons = data;
          console.log("userCancellationReasons", this.userCancellationReasons)
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getPassengers() {
      if (!this.searchPassengerParam) {
        return;
      }
      this.loading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchPassengerParam);
      params.append("getAll", true);
      this.axios
        .get(`passenger`, { params })
        .then((res) => {
          this.passengers = this.normalizeCollection(res.data.data).map((passenger) => ({
            text: `${passenger.full_name}`,
            ...passenger,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    paginate() {
      // no need to do anything, the computed property will update automatically
    },
    removeOrder(order) {
      // implementation
    },
    // other methods

    getData(pdf) {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("from", this.from);
      params.append("to", this.to);
      params.append("reservation", this.reservation ? 1 : 0);
      params.append("instant", this.instant ? 1 : 0);
      params.append("pdf", pdf ? 1 : 0);
      this.axios
        .get("get_automatic_report", {
          responseType: pdf ? "blob" : "json",
          params: params,
        })
        .then((res) => {
          // console.log("data");
          // console.log(res.data);
          if (pdf == false) {
            const excludedKeys = ["pending", "cancelled", "completed", "created", "static_constraints", "captain_cancellation_reason"];
            this.statistics = Object.entries(res.data.data)
              .filter(([key]) => !excludedKeys.includes(key))
              .reduce((obj, [key, value]) => {
                obj[key] = value;
                return obj;
              }, {});
            // res.data.data;
            const counts = Object.entries(res.data.data);
            this.mainStats = counts.filter(([key]) =>
              ["pending", "cancelled", "completed"].includes(key));
            // console.log('main stats');
            // console.log(mainStats);
            // const counts = Object.entries(res.data.data);
            // counts.sort((a, b) => b[1] - a[1]);
            // const hueRange = 60 / 10;
            // const colors = counts.map(
            //   ([key, value], index) => `hsl(${hueRange * index}, 70%, 50%)`
            // );
            // // assign colors to dataset
            // this.chartData.datasets[0].backgroundColor = colors;
            // this.chartData.labels = counts.map(([key, value]) => {
            //   const label = key.replace(/_/g, " ");
            //   return `${label} (${value})`;
            // });
            // this.chartData.datasets[0].data = counts.map(
            //   ([key, value]) => value
            // );
            // this.pieChartData = {
            //   labels: ["Pending", "Cancelled", "Completed"],
            //   datasets: [
            //     {
            //       data: counts
            //         .filter(([key]) =>
            //           ["pending", "cancelled", "completed"].includes(key)
            //         )
            //         .map(([key, value]) => value),
            //       backgroundColor: [
            //         "rgba(255, 206, 86, 0.8)",
            //         "rgba(255, 99, 132, 0.8)",
            //         "rgba(75, 192, 192, 0.8)",
            //       ],
            //     },
            //   ],
            // };
            // const data = this.pieChartData.datasets[0].data;
            // const total = data[0] + data[1] + data[2];
            // const percentages = data.map((value) =>
            //   ((value / total) * 100).toFixed(2)
            // );
            // this.pieChartData.labels = this.pieChartData.labels.map(
            //   (label, index) => `${label} (${percentages[index]}%)`
            // );
            // this.renderChart();
            // this.renderPieChart();
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "AutomaticReport.pdf");
            document.body.appendChild(link);
            link.click();
          }
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
    // renderChart() {
    //   this.chart = new Chart(this.$refs.chart, {
    //     type: "bar",
    //     data: this.chartData,
    //     options: {
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       height: 500,
    //       width: 500,
    //       plugins: {
    //         colorschemes: {
    //           scheme: "tableau.Classic10",
    //         },
    //       },
    //     },
    //   });
    // },
    // renderPieChart() {
    //   this.pieChart = new Chart(this.$refs.pieChart, {
    //     type: "pie",
    //     data: this.pieChartData,
    //     options: {
    //       responsive: true,
    //       maintainAspectRatio: false,
    //       height: 500,
    //       width: 500,
    //       plugins: {
    //         colorschemes: {
    //           scheme: "tableau.Classic10",
    //         },
    //       },
    //     },
    //   });
    // },
    getDynamicConstraints() {
      this.axios
        .get("dynamic_constraints")
        .then((res) => {
          this.constraints = [];
          this.dynamic_constraints.push({
            title: this.$t("statisticsPage.encompt"),
            value: "encompt",
            img: "constraints/en_compt.svg",
          });
          res.data.data.data.forEach((item) => {
            if (item.constraint_name == "pets") {
              this.dynamic_constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/animal.svg",
              });
            } else if (item.constraint_name == "wheelchair") {
              this.dynamic_constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/wheelchair.svg",
              });
            } else if (item.constraint_name == "amex") {
              this.dynamic_constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/amex.svg",
              });
            } else if (item.constraint_name == "low_car") {
              this.dynamic_constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/low_car.svg",
              });
            } else if (item.constraint_name == "mad") {
              this.dynamic_constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: "constraints/mad.svg",
              });
            } else {
              this.dynamic_constraints.push({
                title: item.Abbreviation,
                value: item.id,
                img: false,
              });
            }
            // console.log("constraints");
            // console.log(this.dynamic_constraints);
          });
        })
        .catch((err) => {
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("statisticsPage.constraintsNotLoaded"), "red");
          }
        });
    },
    getVehicleTypes() {
      this.axios
        .get("vehicle_type", {
          perPage: 100

        })
        .then((res) => {
          res.data.data.data.forEach((item) => {
            this.vehicle_types.push(item);
          });
        })
        .catch((err) => {
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("statisticsPage.vehicleTypesNotLoaded"), "red");
          }
        });
    },
    getCaptainCancellationReasons() {
      this.axios
        .get("cancellation-reason")
        .then((res) => {
          const reasons = this.normalizeCollection(res.data.data);
          this.captainCancellationReasons = reasons.filter(
            (item) => item.show_to_captain == 1 || item.showToDriver == 1
          );

          console.log("captainCancellationReasons", this.captainCancellationReasons)
        })
        .catch((err) => {
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("statisticsPage.captainCancellationReasonsNotLoaded"), "red");
          }
        });
    },
    changeFilterMethod(method) {
      //
    },
    searchClusters(query) {
      this.axios
        .get(`location?getAll=true`, { params: { search: query } })
        .then((response) => {
          const tags = this.normalizeCollection(response.data.data).map((tag) => ({
            text: `${tag.name}`,
            value: tag.id,
          }));
          this.autocompleteItems = tags;
          // this.$refs.tagsInput.setOptions(tags)
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
        });
    },
    searchLocations() {
      this.axios
        .get(`get_inside_monaco_sectors`)
        .then((response) => {
          console.log("locations");
          console.log(response.data.data);
          const tags = response.data.data.map((tag) => ({
            text: `${tag.name}`,
            value: tag.id,
          }));
          this.autocompleteItemsPickup = tags;
          // this.$refs.tagsInput.setOptions(tags)
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
        });
    },
    clearFilter() {
      Object.entries(this.customFilter).forEach(([key, value]) => {
        if (key == "destinations") {
          this.customFilter[key] = [];
        } else if (key == "constraints") {
          for (const [key, value] of Object.entries(
            this.customFilter["constraints"]
          )) {
            this.customFilter["constraints"][key] = false;
          }
        } else if (
          key == "selectedUser" ||
          key == "selectedPassenger" ||
          key == "selectedCaptain"
        ) {
          this.customFilter[key] = null;
        } else if (key == "driver_type") {
          this.customFilter[key] = false;
        } else this.customFilter[key] = false;
      });
      this.tags = [];
      this.tagsPickup = [];
      this.message = null;
      this.bookings = [];
      this.customDateFrom = null;
      this.customDateTo = null;
      this.custom_month = null;
      this.custom_year = null;
      this.customFilter.driver_type = "All";
    },
    getCustomReport(pdf, newRequest) {
      if (newRequest) {
        this.pagesCount = 1;
        this.page = 1;
        this.currentPage = 1;
      }
      this.loading = true;
      const params = new URLSearchParams();
      params.append("page", this.currentPage);

      Object.entries(this.customFilter).forEach(([key, value]) => {
        if (
          key == "destinations" ||
          key == "driver_type" ||
          key == "selectedCaptain" ||
          key == "selectedUser" ||
          key == "selectedPassenger"
        ) {
          if (value != undefined && value != null && value != 0)
            params.append(key, value);
        } else {
          params.append(key, value ? 1 : 0);
        }
      });

      if (this.tags.length == 0) params.delete("destinations");
      else {
        var destinations = [];
        Object.entries(this.tags).forEach(([key, tag]) => {
          destinations.push(tag.value);
        });
        params.append("destinations", destinations);
      }
      if (this.tagsPickup.length == 0) params.delete("pickups");
      else {
        var pickups = [];
        Object.entries(this.tagsPickup).forEach(([key, tag]) => {
          pickups.push(tag.value);
        });
        params.append("pickups", pickups);
      }
      if (this.customFilter.constraints.length == 0)
        params.delete("constraints");
      else {
        var constraints = [];
        Object.entries(this.customFilter.constraints).forEach(
          ([key, value]) => {
            if (value != null && value != 0) constraints.push(key);
          }
        );
        if (constraints.length > 0)
          params.append("constraints", constraints);
        else
          params.delete("constraints");
      }
      if (this.customFilter.captainCancellationReasons.length == 0)
        params.delete("captainCancellationReasons");
      else {
        var captainCancellationReasons = [];
        Object.entries(this.customFilter.captainCancellationReasons).forEach(
          ([key, value]) => {
            if (value != null && value != 0) captainCancellationReasons.push(key);
          }
        );
        if (captainCancellationReasons.length > 0)
          params.append("captainCancellationReasons", captainCancellationReasons);
        else
          params.delete("captainCancellationReasons");
      }
      if (this.customFilter.userCancellationReasons.length == 0)
        params.delete("userCancellationReasons");
      else {
        var userCancellationReasons = [];
        Object.entries(this.customFilter.userCancellationReasons).forEach(
          ([key, value]) => {
            if (value != null && value != 0) userCancellationReasons.push(key);
          }
        );
        if (userCancellationReasons.length > 0)
          params.append("userCancellationReasons", userCancellationReasons);
        else
          params.delete("userCancellationReasons");
      }
      if (this.customFilter.vehicle_types.length == 0)
        params.delete("vehicle_types");
      else {
        var vehicle_types = [];
        Object.entries(this.customFilter.vehicle_types).forEach(
          ([key, value]) => {
            if (value != null && value != 0) vehicle_types.push(key);
          }
        );
        if (vehicle_types.length > 0)
          params.append("vehicle_types", vehicle_types);
        else
          params.delete("vehicle_types");

      }
      // this.customFilter.destinations = [];
      if (this.tags.length > 0) this.customFilter.destinations = this.tags;
      if (this.tagsPickup.length > 0)
        this.customFilter.pickups = this.tagsPickup;
      if (pdf == true) {
        params.append("pdf", 1);
        params.append("message", this.message);
      }
      params.append("from", this.customDateFrom);
      params.append("to", this.customDateTo);
      this.axios
        .get("get_custom_report", {
          responseType: pdf ? "blob" : "json",
          params: params,
        })
        .then((res) => {
          console.log("data");
          console.log(res.data.data);
          if (pdf == false) {
            this.bookings = res.data.data.bookings.data;
            this.message = res.data.data.message;
            this.pagesCount = res.data.data.bookings.last_page;
            this.page = res.data.data.bookings.current_page;
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "AutomaticReport.pdf");
            document.body.appendChild(link);
            link.click();
          }
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.loading = false;
        });
    },
  },
  watch: {
    searchPassengerParam() {
      this.getPassengers();
    },
    searchCaptainParam() {
      this.getCaptains();
    },
    searchUserParam() {
      this.getUsers();
    },
    custom_month(value) {
      this.customDateFrom = moment(value).startOf("month").format("YYYY-MM-DD");
      this.customDateTo = moment(value).endOf("month").format("YYYY-MM-DD");
    },
    custom_year(value) {
      this.customDateFrom = moment(value, "YYYY")
        .startOf("year")
        .format("YYYY-MM-DD");
      this.customDateTo = moment(value, "YYYY")
        .endOf("year")
        .format("YYYY-MM-DD");
    },
    currentPage(value) {
      this.getCustomReport(false, false);
    },
    customFilter: {
      handler(newModel, oldValue) {
        console.log("watcher SelectedCaptain");
        console.log(this.customFilter.selectedCaptain);
        console.log("watcher SelectedUser");
        console.log(this.customFilter.selectedUser);
        console.log("watcher SelectedPassenger");
        console.log(this.customFilter.selectedPassenger);
      },
      deep: true,
    },
    selected_month(val) {
      (this.from = moment(val).startOf("month").format("YYYY-MM-DD")),
        (this.to = moment(val).endOf("month").format("YYYY-MM-DD")),
        this.getData(false);
    },
    selected_year(val) {
      (this.from = moment(val, "YYYY").startOf("year").format("YYYY-MM-DD")),
        (this.to = moment(val, "YYYY").endOf("year").format("YYYY-MM-DD")),
        this.getData(false);
    },
    selected_day(val) {
      // console.log(val);
      this.from = moment(val).format("YYYY-MM-DD");
      this.to = moment(val).format("YYYY-MM-DD");
      this.getData(false);
    },
    from(val) {
      if ( this.selected_filter_by == "Day" && val != null && this.to != null) {
        this.getData(false);
      }
    },
    to(val) {
      if ( this.selected_filter_by == "Day" && val != null && this.from != null) {
        if (this.from == null) this.from = this.to;
        this.getData(false);
      }
    },
    selected_type(val) {
      // console.log(val);
      this.reservation = true;
      this.instant = true;
      if (val == "Reservation") this.instant = false;
      else if (val == "Instant") this.reservation = false;
      this.getData(false);
    },
  },
  computed: {
    typeOptions() {
      return [
        { text: this.$t("statisticsPage.typeAll"), value: "All" },
        { text: this.$t("statisticsPage.typeReservation"), value: "Reservation" },
        { text: this.$t("statisticsPage.typeInstant"), value: "Instant" },
      ];
    },
    filterByOptions() {
      return [
        { text: this.$t("statisticsPage.filterDay"), value: "Day" },
        { text: this.$t("statisticsPage.filterMonth"), value: "Month" },
        { text: this.$t("statisticsPage.filterYear"), value: "Year" },
      ];
    },
    driverTypeOptions() {
      return [
        { text: this.$t("statisticsPage.driverTypeAll"), value: "All" },
        { text: this.$t("statisticsPage.driverTypeNormal"), value: "Normal" },
        { text: this.$t("statisticsPage.driverTypeSeasonal"), value: "Seasonal" },
        { text: this.$t("statisticsPage.driverTypeSpecific"), value: "Specific" },
      ];
    },
    paginatedBookings() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.bookings.slice(startIndex, endIndex);
    },

    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
    filteredPickups() {
      return this.autocompleteItemsPickup.filter((i) => {
        return (
          i.text.toLowerCase().indexOf(this.tagPickup.toLowerCase()) !== -1
        );
      });
    },
  },
  formatter() {
    return {
      active(val) {
        //language=HTML
        return `
                      <i class="v-icon fa ${val ? "fa-check" : "fa-close"}"></i>
                      `;
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.options {
  width: 100%;
  float: inline-start;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2.5em;
  gap: 16px;

  // gap: 16px;
  .option {
    float: inline-start;
    border: 1px solid #788e98;
    border-radius: 12px;
    overflow: hidden;
    min-width: 120px;

    .title {
      width: 100%;
      background: #ced3d4;
      padding: 12px 18px;
      float: inline-start;
      color: #202731;
      font-size: 12pt !important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1px;

      .count {
        color: rgb(197, 203, 204);
        font-size: 8pt;
        padding: 4px;
        border-radius: 4px;
        background: rgb(97, 127, 133);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 85%;
        min-width: 24px;
        height: 24px;
      }
    }

    .percentage {
      width: 100%;
      padding: 0 12px;
      font-size: 18pt;
      color: #202731;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 700;

      .symbol {
        color: #788e98;
        font-size: 12pt;
        font-weight: 400;
        margin-inline-start: 4px;
      }
    }
  }
}

.vue-tags-input {
  background: #324652;
  width: 100%;
  max-width: none !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent;
  width: 100%;
  color: #b7c4c9;
}

.vue-tags-input .ti-input {
  background: #fafafa;
  padding: 14px 10px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid black;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ff5252;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #283944;
  border: 1px solid #8b9396;
  border-top: none;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item.ti-selected-item {
  background: #ebde6e;
  color: #283944;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative;
  background: #ebde6e;
  color: #283944;
  overflow: hidden;
}

/* we defined a custom css class in the data model, now we are using it to style the tag */
.vue-tags-input .ti-tag.custom-class {
  background: transparent;
  border: 1px solid #ebde6e;
  color: #ebde6e;
  margin-inline-end: 4px;
  border-radius: 0px;
  font-size: 13px;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  inset-inline-start: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}

.tab {
  color: #e21024 !important;
}

.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

body {
  font-family: system-ui;
}

table,
th {
  border: 1px solid black;
  border-collapse: collapse;
}

td {
  text-align: center;
}

.bordered {
  border: 1px solid black;
  border-collapse: collapse;
}

.half-bordered {
  border-inline-start: 1px solid black;
  border-inline-end: 1px solid black;
  border-collapse: collapse;
}

.column {
  float: inline-start;
  width: 50%;
  box-sizing: border-box;
}

.column1 {
  float: inline-start;
  width: 30%;
  box-sizing: border-box;
}

.column2 {
  float: inline-start;
  width: 35%;
  box-sizing: border-box;
}

.column3 {
  float: inline-start;
  width: 35%;
  box-sizing: border-box;
}

.row:after {
  content: "";
  display: table;
  clear: both;
  box-sizing: border-box;
  width: 100%;
  padding-top: 10px;
}
</style>